import { createRouter, createWebHistory } from 'vue-router'
import AuthedLayout from "@/views/layouts/AuthedLayout.vue";
import PublicLayout from "@/views/layouts/PublicLayout.vue";
import AuthLayout from "@/views/layouts/AuthLayout.vue";
import {useUserStore} from "@/stores/user.js";

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      meta: { layout: PublicLayout },
      component: () => import('../views/public/HomeView.vue'),
    },
    {
      path: '/login',
      name: 'login',
      meta: { layout: AuthLayout },
      component: () => import('../views/public/LoginView.vue'),
    },
    {
      path: '/reset-password',
      name: 'resetPassword',
      meta: { layout: AuthLayout },
      component: () => import('../views/public/ResetPasswordView.vue'),
    },
    {
      path: '/new-password',
      name: 'newPassword',
      meta: { layout: AuthLayout },
      component: () => import('../views/public/NewPasswordView.vue'),
    },
    {
      path: '/register',
      name: 'register',
      meta: { layout: AuthLayout },
      component: () => import('../views/public/RegisterView.vue'),
    },
    {
      path: '/verify-email',
      name: 'verifyEmail',
      meta: { layout: AuthLayout },
      component: () => import('../views/public/VerifyEmailView.vue'),
    },
    {
      path: '/verify-oauth',
      name: 'verifyOauth',
      meta: { layout: AuthLayout },
      component: () => import('../views/public/VerifyOauthView.vue'),
    },
    {
      path: '/select-plan',
      name: 'selectPlan',
      meta: { auth: true, layout: AuthLayout },
      component: () => import('../views/authed/PlanSelectView.vue'),
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      meta: { auth: true, forceUserRefresh: true, layout: AuthedLayout },
      component: () => import('../views/authed/DashboardView.vue'),
    },
    {
      path: '/imagesets',
      meta: { auth: true, layout: AuthedLayout },
      children: [
        {
          path: '',
          name: 'imagesets.index',
          component: () => import('../views/authed/Imagesets/ImagesetsIndexView.vue'),
        },
        {
          path: 'create',
          name: 'imagesets.create',
          component: () => import('../views/authed/Imagesets/ImagesetsCreateView.vue'),
        },
        {
          path: ':imagesetId',
          name: 'imagesets.edit',
          component: () => import('../views/authed/Imagesets/ImagesetsEditView.vue'),
          props: true,
        },
      ]
    },
    {
      path: '/account',
      name: 'account',
      meta: { auth: true, forceUserRefresh: true, layout: AuthedLayout },
      component: () => import('../views/authed/AccountView.vue'),
    },
  ],
  scrollBehavior(to) {
    if(to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth',
      }
    }
  }
})

router.afterEach(async (to) => {
  const userStore = useUserStore();

  if(to.meta?.forceUserRefresh) {
    userStore.forceRefreshNextFetch();
  }

  try {
    await userStore.getUser();
    /* eslint-disable */
  } catch(e) {}
});

export default router
